import {
  BaSeContainer,
  BaSeHeading2,
  BaSeHeading5,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { JumbotronContainer, JumbotronContent } from './layout-styled';


const EadTitlePage = ({
  title,
  subtitle,
  backgroundColor = BaSeTheme.colors.defaultColors.white,
}) => {
  return (
    <JumbotronContainer backgroundColor={backgroundColor}>
      <BaSeContainer delimitedOnBreakpoint="desktop">
        <JumbotronContent>
          <div>
            <BaSeHeading2 color={BaSeTheme.colors.institucionais.azulSebrae30}>
              {title}
            </BaSeHeading2>
            <BaSeHeading5 color={BaSeTheme.colors.institucionais.azulSebrae30}>
              {subtitle}
            </BaSeHeading5>
          </div>
        </JumbotronContent>
      </BaSeContainer>
    </JumbotronContainer>
  );
};

export { EadTitlePage as default };
